export const NOTIFICATION_FORM_COMPONENT_KEY = 'CartCouponsComponent'

export const NOTIFICATION_FORM_DEFAULT_CONFIG = {

}
